export const CREATE_ARCHITECTUREDASHBOARD = "CREATE_ARCHITECTUREDASHBOARD";
export const RETRIEVE_ARCHITECTUREDASHBOARD = "RETRIEVE_ARCHITECTUREDASHBOARD";
export const RETRIEVESINGLE_ARCHITECTUREDASHBOARD = "RETRIEVESINGLE_ARCHITECTUREDASHBOARD";
export const UPDATE_ARCHITECTUREDASHBOARD = "UPDATE_ARCHITECTUREDASHBOARD";
export const DELETE_ARCHITECTUREDASHBOARD = "DELETE_ARCHITECTUREDASHBOARD";


